import { render } from "./AuszahlungWechselModalitaetData.pug?vue&type=template&id=0a297b43&lang=pug"
import script from "./AuszahlungWechselModalitaetData.js?vue&type=script&lang=js"
export * from "./AuszahlungWechselModalitaetData.js?vue&type=script&lang=js"

import "./AuszahlungWechselModalitaetData.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__